function PageTopAnime() {
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
    $("#page-top").removeClass("DownMove");
    $("#page-top").addClass("UpMove");
  } else {
    if ($("#page-top").hasClass("UpMove")) {
      $("#page-top").removeClass("UpMove");
      $("#page-top").addClass("DownMove");
    }
  }
}
$(window).scroll(function () {
  PageTopAnime();
});
$(window).on("load", function () {
  PageTopAnime();
});
$("#page-top a").click(function () {
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    500
  );
  return false;
});
$(function () {
  $(".tab-btn").on("click", function () {
    var tabWrap = $(this).parents(".tab-wrap");
    var tabBtn = tabWrap.find(".tab-btn");
    var tabContents = tabWrap.find(".tab-contents");
    tabBtn.removeClass("show");
    $(this).addClass("show");
    var elmIndex = tabBtn.index(this);
    tabContents.removeClass("show");
    tabContents.eq(elmIndex).addClass("show");
  });
});

if (window.matchMedia("(max-width:600px)").matches) {
  $(function () {
    $('nav a[href^="#"]').click(function () {
      var adjust = 50;
      var speed = 700;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top - adjust;
      $("body,html").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });
} else {
  $(function () {
    $('nav a[href^="#"]').click(function () {
      var adjust = 136;
      var speed = 700;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);
      var position = target.offset().top - adjust;
      $("body,html").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  });
}

$(function () {
  var $header = $("header");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      $header.addClass("change-color");
    } else {
      $header.removeClass("change-color");
    }
  });
});

/* fadeUp */
function fadeAnime() {
  $(".fadeUpTrigger").each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("fadeUp");
    } else {
      $(this).removeClass("fadeUp");
    }
  });
}
$(window).scroll(function () {
  fadeAnime();
});

/* fadeRight */
function fadeAnimeRight() {
  $(".fadeRightTrigger").each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("fadeRight");
    } else {
      $(this).removeClass("fadeRight");
    }
  });
}
$(window).scroll(function () {
  fadeAnimeRight();
});

$(function () {
  $(".accordionBox dt").click(function () {
    $(".accordionBox dt").not(this).removeClass("open");
    $(this).toggleClass("open");
    $(this).next().slideToggle(400);
  });
});

$(".menuTrigger").click(function () {
  $(this).toggleClass("active");
});
$(".menuTrigger").on("click", function () {
  $(".menu").toggleClass("menu--isOpen");
  $(this).toggleClass("activeTrigger");
});
$(".menu a").on("click", function () {
  $(".menu").removeClass("menu--isOpen");
  $(".menuTrigger").removeClass("activeTrigger");
  $(".menuTrigger").removeClass("active");
});

document.addEventListener("DOMContentLoaded", () => {
  const detailImgs = document.querySelectorAll(
    ".p_shopSingleDetailBox .detailImgBox"
  );

  for (const detailImg of detailImgs) {
    const scrollHint = document.createElement("div");
    scrollHint.className = "scroll-hint scroll-hint--show";
    detailImg.appendChild(scrollHint);

    const showScrollHint = () => {
      if (detailImg.scrollWidth > detailImg.clientWidth) {
        scrollHint.classList.add("scroll-hint--show");
      } else {
        scrollHint.classList.remove("scroll-hint--show");
      }
    };
    showScrollHint();

    detailImg.addEventListener("scroll", () => {
      scrollHint.classList.remove("scroll-hint--show");
    });
  }
});

const swiper14 = new Swiper(".js-shopSingleImage-thumbnail", {
  // loop: false,
  slidesPerView: 3, // 一度に表示する枚数
  spaceBetween: 8,
});
const swiper15 = new Swiper(".js-shopSingleImage-main", {
  loop: true,
  thumbs: {
    swiper: swiper14,
  },
});
// $(function () {
//   $(".acMenu01 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu02 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu03 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu04 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu05 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu06 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $(".acMenu07 dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });

// $(function () {
//   $("[class^='acMenu'] dt").on("click", function () {
//     $(this).next().slideToggle();
//     $(this).toggleClass("active");
//   });
// });

// $(function () {
//   $("[class^='acMenu'] dt").on("click", function () {
//     $(this).next().slideToggle();
//     $(this).toggleClass("active");
//     $(this).next("dd").toggleClass("active");
//   });
// });
// $(function () {
//   $("[class^='acMenu'] dt").on("click", function () {
//     $(this).next("dd").slideToggle();
//     $(this).next("dd").toggleClass("active");
//     $(this).toggleClass("active");
//   });
// });
// $(function () {
//   $("[class^='acMenu'] dt").on("click", function () {
//     $(this).toggleClass("active");
//     $(this).next("dd").slideToggle().toggleClass("active");
//   });
// });
$(function () {
  $(".acMenu dt").on("click", function () {
    $(this).next().slideToggle(), $(this).toggleClass("active");
  });
});

const swiper4 = new Swiper(".serviceSwiper", {
  loop: false,
  speed: 300,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dots: false,
    renderBullet: function (index, className) {
      let text = "";
      switch (index) {
        case 0:
          text = '<span class="en">01</span><span class="jp">各種工場床</span>';
          break;
        case 1:
          text = '<span class="en">02</span><span class="jp">厨房床</span>';
          break;
        case 2:
          text = '<span class="en">03</span><span class="jp">段差解消</span>';
          break;
        case 3:
          text = '<span class="en">04</span><span class="jp">店舗床</span>';
          break;
        case 4:
          text = '<span class="en">05</span><span class="jp">駐車場</span>';
          break;
        case 5:
          text = '<span class="en">06</span><span class="jp">住宅</span>';
          break;
        case 6:
          text = '<span class="en">07</span><span class="jp">その他施設</span>';
          break;
        case 7:
          text = '<span class="en">08</span><span class="jp">研磨、撤去</span>';
          break;
        default:
          text = "";
          break;
      }
      return '<span class="' + className + '">' + text + "</span>";
    },
  },
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next01",
    prevEl: ".swiper-button-prev01",
  },
});

const swiper5 = new Swiper(".worksSwiper", {
  speed: 300,
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next02",
    prevEl: ".swiper-button-prev02",
  },
});

const swiper6 = new Swiper(".detailsSwiper01", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination01",
    clickable: true,
  },
});
const swiper7 = new Swiper(".detailsSwiper02", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination02",
    clickable: true,
  },
});
const swiper8 = new Swiper(".detailsSwiper03", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination03",
    clickable: true,
  },
});
const swiper9 = new Swiper(".detailsSwiper04", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination04",
    clickable: true,
  },
});
const swiper10 = new Swiper(".detailsSwiper05", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination05",
    clickable: true,
  },
});
const swiper11 = new Swiper(".detailsSwiper06", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination06",
    clickable: true,
  },
});
const swiper12 = new Swiper(".detailsSwiper07", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination07",
    clickable: true,
  },
});
const swiper13 = new Swiper(".detailsSwiper08", {
  loop: true,
  speed: 1500,

  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: ".swiper-pagination08",
    clickable: true,
  },
});

// $(function () {
//   $(".acMenu dt").on("click", function () {
//     $(this).next().slideToggle(), $(this).toggleClass("active");
//   });
// });

$(function () {
  $(".tab-btn").on("click", function () {
    var tabWrap = $(this).parents(".tab-wrap");
    var tabBtn = tabWrap.find(".tab-btn");
    var tabContents = tabWrap.find(".tab-contents");
    var elmIndex = tabBtn.index(this);
    tabBtn.removeClass("show");
    tabContents.removeClass("show");
    $(this).addClass("show");
    tabContents.eq(elmIndex).addClass("show");
    var tabText = $(this).attr("id");
    window.location.hash = tabText;
  });

  // Load the correct tab on page load based on the URL hash
  var hash = window.location.hash;
  if (hash) {
    $(".tab-btn" + hash).click();
  }
});
